import "./../../styles/dashboard.css";
import { ModernCategoryCard } from "../category/ModernCategoryGrid";

const GiftCardSection = ({ title, utilities }) => {
  const activeUtilities = utilities?.filter((util) => util.product_status === "active");
  if (activeUtilities?.length <= 0) return null;

  return (
    <section className="account-section-container">
      <div className="account-category">
        <div className="category-title-container">
          <h2 className="category-title">{title}</h2>
        </div>

        <div className="dashboard-product-grid mgc-grid mgc-grid--game">
          {activeUtilities?.map((util) => (
            <ModernCategoryCard key={util._id} item={util} type="game" />
          ))}
        </div>
      </div>
    </section>
  );
};

export default GiftCardSection;
